import $ from "jquery";
import moment from "moment";
import Seed from "DMS/Seed/All";
import * as GoogleMapStarter from "DMS/Utils/GoogleMapStarter";
import { resizeScreen } from "DMS/Utils/resizeScreen";
import { notify } from "DMS/Utils/modal";
import { rqListSearch } from "DMS/Controllers/listController";
import { toggleTraffic, toggleFlyPath, clearMarkers, removeInfoPanel, changeMapWidth } from "DMS/Controllers/geolocController";
/**
 * Appel du planning global
 * @param int numdossier Numéro du dossier
 * @param string date Date
 * @param string calendarMode Mode du calendrier
 * @param string secteur Filtre sur le secteur
 * @param string agence Filtre sur l'agence
 * @param string tech Filtre sur le technicien
 */
function Planning(numdossier, date, calendarMode, secteur, agence, tech, idtechnicien, competence, tacheStdOrDetail, planningTypeSemaine) {
    numdossier = numdossier ? numdossier : '';
    date = date ? date : '';
    calendarMode = calendarMode ? calendarMode : '';
    secteur = secteur ? secteur : '';
    agence = agence ? agence : '';
    tech = tech ? tech : '';
    idtechnicien = idtechnicien ? idtechnicien : '';
    competence = competence ? competence : '';
    tacheStdOrDetail = tacheStdOrDetail ? tacheStdOrDetail : '';
    planningTypeSemaine = planningTypeSemaine ? planningTypeSemaine : '';
    var parent = Seed.Tab.GetFrame();
    var planningCart = '<div class="col-sm-2 hidden-xs task-panel" style="float: right; z-index: 100; display: none;"></div>';
    var planningPanelClass = 'col-sm-10 planning-panel';
    if (!Seed.Planning.planning_cart) {
        planningCart = '';
        planningPanelClass = 'col-sm-12 planning-panel';
    }
    // z-index: 200 pour que le calendrier, enfant de .planning-panel
    // passe au dessus de .task-panel avec z-index: 100 (defini ci-dessus)
    var container = '<div id="planning-wrapper" class="row">'
        + '<div class="' + planningPanelClass + '" style="position: fixed; z-index: 200;"></div>'
        + planningCart
        + '</div>';
    $(parent).html(container);
    // le 1er argument, 'all' ou 'parts' indique si on rafraichi l'ensemble du planning
    // ou les elements separes pour preserver la google map
    // 
    // pour distinguer le conteneur googleMap créé dans un nouvel onglet
    // pour la géolocalisation "pure" du conteneur googleMap créé dans le planning (ci-dessous)
    // on ajoute à ce dernier conteneur l'attribut data-container="planning"
    // utile pour distinguer les conteneurs dans la fonction changeMapWidth (geolocController.js)
    //
    // le 2ème argument : planningOrGeoloc indique si on doit afficher l'onglet planning
    // en mode planning i.e. le bouton de geoloc est nommé 'geolocalisation'
    // et le planning est mis à jour
    // ou en mode geoloc i.e. le bouton geoloc est nommé 'planning',
    // le type de geolocalisation est le type par defaut = 'position'
    // le planning n'est pas renvoyé (pas mis à jour)
    refreshPlanning('all', 'planning', numdossier, date, calendarMode, secteur, agence, tech, idtechnicien, competence, tacheStdOrDetail, planningTypeSemaine);
    if (Seed.Planning.planning_cart && Seed.Planning.planningUserLockright)
        rqListSearch(3045, "", Seed.Tab.GetFrame().find('.task-panel')[0]);
}
export function initializePlanning(numdossier, planningCart, lockRight) {
    Seed.Tab.AddTab();
    Seed.Tab.SetText("Planning");
    Seed.Planning.planning_cart = planningCart;
    Seed.Planning.planningUserLockright = lockRight;
    Planning(numdossier, '', '');
}
export function showPlanning(planningOrGeoloc, calendarMode, postNumDossier, tech, postSecteur, agence, competence, dateString, date1, planningLock, techos, tacheStdOrDetail, planningTypeSemaine) {
    Seed.Planning.Init(calendarMode, postSecteur, competence, postNumDossier);
    // utilisation du widget "bootstrap 3 datepicker"
    // (https://eonasdan.github.io/bootstrap-datetimepicker/)
    Seed.Tab.GetFrame().find(".planning-panel .SM-datepicker")
        .datetimepicker({
        locale: moment.locale(),
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar-o',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down',
            previous: 'fa fa-angle-left',
            next: 'fa fa-angle-right',
            today: 'fa fa-crosshairs',
            clear: 'fa fa-trash'
        },
        showTodayButton: true,
        format: "L",
        calendarWeeks: true,
        ignoreReadonly: true
    })
        // mise à jour du planning lorsque le widget est masqué
        // e est la date courante du widget
        .on("dp.hide", (e) => refreshPlanning('parts', planningOrGeoloc, postNumDossier, e.date.format("YYYY-MM-DD"), calendarMode, postSecteur, agence, tech, '', competence, tacheStdOrDetail, planningTypeSemaine));
    // met à jour la date du widget "bootstrap 3 datepicker"
    // (https://eonasdan.github.io/bootstrap-datetimepicker/)
    // @todo : j'ai l'impression que cette fonction est appelée trop tôt. J'ai mis un "each" pour ne pas avoir de "undefined"
    Seed.Tab.GetFrame().find(".planning-panel .SM-datepicker").each((index, elem) => $(elem).data("DateTimePicker").date(moment(date1)));
    // aucun technicien pour les filtres saisis => message
    if (techos === '') {
        Seed.Tab.GetFrame().find("#Planning")
            .append("<div class='noRecord'>" + MSG_NO_RECORD + "</div>");
        // si on est sur la geoloc, on ne voit pas le message precedent
        notify(MSG_NO_RECORD);
    }
    else {
        if (calendarMode === "semaine" || calendarMode === "mois") {
            Seed.Tab.GetFrame().popover({
                selector: '[data-popover]',
                trigger: 'hover',
                delay: { show: 50, hide: 400 }
            });
            // Traduction
            Seed.Planning.formatData();
        }
        else if (calendarMode === "semainedetail") {
            Seed.Planning.LoadWeek(dateString, tech, postNumDossier, postSecteur, tacheStdOrDetail, planningTypeSemaine);
        }
        else if (calendarMode === "jourdetail" || calendarMode === "jour") {
            Seed.Planning.LoadDayAll(dateString, tech, postNumDossier, postSecteur, competence);
        }
        Seed.Planning.setLock(planningLock);
        resizeScreen();
        Seed.Planning.formatData();
        Seed.Planning.locking();
        if (!Seed.Planning.isCartVisible()) {
            Seed.Planning.hideCart();
        }
        else {
            Seed.Planning.showCart();
        }
    }
}
export function resizeTasks() {
    Seed.Planning.taskWidth = parseInt(Seed.Tab.GetFrame().find('tbody').children('tr.droppable:first').children(':first').width()) + 2;
    Seed.Tab.GetFrame().find('.tacheDay').each((index, elem) => {
        $(elem).css("width", Seed.Planning.taskWidth),
            $(elem).draggable({
                grid: [Seed.Planning.taskWidth, Seed.Planning.Unit]
            });
    });
}
export function refreshPlanningAndList(numdossier, date, calendarMode, secteur, agence, nomtechnicien, idtechnicien, competence, tacheStdOrDetail, planningTypeSemaine) {
    let isGeolocMode = Seed.Tab.GetFrame().find('.googleMap').css('display') != 'none';
    // en mode 'geoloc' : force le mode 'jour'
    if (isGeolocMode) {
        calendarMode = 'jour';
    }
    if (nomtechnicien === "") {
        calendarMode = calendarMode.replace("detail", "");
    }
    else if (calendarMode.indexOf("detail") === -1) {
        calendarMode = calendarMode + "detail";
    }
    Seed.Planning.SetMode(calendarMode);
    refreshPlanning('parts', (isGeolocMode ? 'geoloc' : 'planning'), numdossier, date, calendarMode, secteur, agence, nomtechnicien, idtechnicien, competence, tacheStdOrDetail, planningTypeSemaine);
    if (!isGeolocMode) {
        refreshListPlanning();
        Seed.Planning.setDragAndDrop();
        resizeTasks();
    }
}
// @todo : pourquoi cette fonction est async ?
async function getFilters_planning() {
    return {
        idtechnicien: {
            value: Seed.Tab.GetFrame().find('#technicien')
                .children('option')
                .filter(':selected')
                .data('index'),
            "table-to-join": "xtechnicien",
            operator: "eq"
        },
        nomtechnicien: {
            value: Seed.Tab.GetFrame().find('#technicien').val(),
            "table-to-join": "xtechnicien",
            operator: "eq"
        },
        secteur: {
            value: Seed.Tab.GetFrame().find('#secteur').val(),
            "table-to-join": "xsecteur",
            operator: "eq"
        },
        competence: {
            value: Seed.Tab.GetFrame().find('#skill').val(),
            "table-to-join": "techniciencompetence",
            operator: "eq"
        },
        date: {
            // recupere la date du widget "bootstrap 3 datepicker"
            // (https://eonasdan.github.io/bootstrap-datetimepicker/)
            value: Seed.Tab.GetFrame().find(".planning-panel .SM-datepicker")
                .data("DateTimePicker")
                .date().format("YYYY-MM-DD"),
            "table-to-join": "",
            operator: ''
        }
    };
}
// execution lors du clic sur le bouton "geolocalisation" du planning
export function toggleAndRefreshPlanningOrGeoloc(numdossier, date, calendarMode, secteur, agence, nomtechnicien, idtechnicien, competence, tacheStdOrDetail, planningTypeSemaine) {
    let filters_obj = {
        idtechnicien: {
            value: idtechnicien,
            "table-to-join": "xtechnicien",
            operator: "eq"
        },
        nomtechnicien: {
            value: nomtechnicien,
            "table-to-join": "xtechnicien",
            operator: "eq"
        },
        secteur: {
            value: secteur,
            "table-to-join": "xsecteur",
            operator: "eq"
        },
        competence: {
            value: competence,
            "table-to-join": "techniciencompetence",
            operator: "eq"
        },
        tacheStdOrDetail: {
            value: tacheStdOrDetail,
            "table-to-join": "",
            operator: ""
        },
        planningTypeSemaine: {
            value: planningTypeSemaine,
            "table-to-join": "",
            operator: ""
        },
        date: {
            value: date,
            "table-to-join": "",
            operator: ''
        }
    };
    // l'element googleMap est créé dans la fonction Planning
    // il est enfant de #panel-planning et au même niveau que #Planning
    // googleMap a la classe resizable comme #Planning, pour prendre
    // en charge son redimensionnement de la meme maniere
    let $googleMap = Seed.Tab.GetFrame().find('.googleMap');
    let $planning = Seed.Tab.GetFrame().find('#Planning');
    let currentTabId = Seed.Tab.GetCurrentTabID();
    let $openedGoogleMap = $('.googleMap[data-tab]');
    // La carte a été ouverte ailleurs
    if ($openedGoogleMap.length !== 0
        && $openedGoogleMap.attr('data-tab') != currentTabId) {
        GoogleMapStarter.removeLoadEffect();
        notify(msgmapalreadyopened);
        return;
    }
    else {
        $googleMap.attr('data-tab', currentTabId);
    }
    $planning.toggle();
    $googleMap.toggle();
    // si la google map est affichee, on la met à jour 
    if ($googleMap.is(":visible")) {
        removeInfoPanel().then(changeMapWidth);
        // mode geoloc => force le mode 'jour'
        // et interdit l'utilisation des boutons semaine et mois
        // mode jour => tacheStdOrDetail = planningTypeSemaine = ''
        if ($googleMap.children().length > 0)
            refreshPlanning('parts', 'geolocInit', numdossier, date, 'jour', secteur, agence, nomtechnicien, idtechnicien, competence, '', '');
        $planning.data('state', 'position');
        if (!$googleMap.children().length > 0) {
            noData = window.noDataLbl;
            GoogleMapStarter.changeUrlPrefix("_module/Geoloc/");
            GoogleMapStarter.changeIsPlanning(true);
            GoogleMapStarter.createMap().then(() => {
                refreshPlanning('parts', 'geolocInit', numdossier, date, 'jour', secteur, agence, nomtechnicien, idtechnicien, competence, '', '');
            });
            // updateGeoloc('init', filters_obj, () => refreshPlanning('parts', 'geolocInit', numdossier, date, 'jour', secteur, agence, nomtechnicien, idtechnicien, competence, tacheStdOrDetail, planningTypeSemaine));
        }
    }
    // c'est le planning qui est affiché => rafraichissement
    else {
        if ($googleMap.children().length > 0) {
            toggleTraffic(false);
            toggleFlyPath(false, true);
            window.displayTraffic = false;
            window.displayBirdFly = false;
        }
        // supprime le div "#information_panel"
        removeInfoPanel();
        // calendarMode = jour, jourdetail, semaine, semainedetail, mois ou moisdetail
        refreshPlanning('parts', 'planning', numdossier, date, calendarMode, secteur, agence, nomtechnicien, idtechnicien, competence, tacheStdOrDetail, planningTypeSemaine);
    }
    resizeScreen();
    // Fermeture de l'onglet
    // Apparemment il ne faut pas supprimer la carte : https://stackoverflow.com/questions/11444826/unload-google-maps-api
    $("#planning_tab .Seed_Tab_Close").click(() => $googleMap.hide());
}
// entrees :
// - type de geoloc : 'init', 'position', 'depart', 'arrivee' ou 'tour'
// - planningFilters_obj = objet contenant les filtres du planning :
// 
// { numdossier: { value: numdossier,
//                 "table-to-join": "",
//                 operator: "" },
//   agence: { value: agence,
//            "table-to-join": "",
//            operator: "" },
//   date: { value: Seed.Tab.GetFrame().find( ".planning-panel .SM-datepicker" )
//                                     .data( "DateTimePicker" )
//                                     .date().format( "YYYY-MM-DD" ),
//          "table-to-join": "",
//          operator: "" },
//  secteur: { value: Seed.Tab.GetFrame().find( '#secteur' ).val(),
//             "table-to-join": "xsecteur",
//             operator: "eq" },
//  nomtechnicien: { value: Seed.Tab.GetFrame().find( '#technicien' ).val(),
//                   "table-to-join": "xtechnicien",
//                   operator: "eq" },
//  idtechnicien: { value: Seed.Tab.GetFrame().find( '#technicien' )
//                                              .children( 'option' )
//                                              .filter( ':selected' )
//                                              .data( 'index' ),
//                    "table-to-join": "xtechnicien",
//                    operator: "eq" },
//  competence: { value: Seed.Tab.GetFrame().find( '#skill' ).val(),
//                "table-to-join": "techniciencompetence",
//                operator: "eq" } }
//
function updateGeoloc(geolocType, planningFilters_obj, callback) {
    function filtersLoaded(planningFilters_async_obj) {
        if (geolocType == 'init') {
            GoogleMapStarter.changeUrlPrefix("_module/Geoloc/");
            GoogleMapStarter.changeIsPlanning(true);
        }
        else {
            // pour la tournée, le filtre à fournir en entree doit avoir le format :
            // filters = { 'date': chosenDate, 'bbmindex': techBbmindex }
            if (geolocType == 'tour') {
                planningFilters_async_obj = {
                    date: planningFilters_async_obj.date.value,
                    bbmindex: planningFilters_async_obj.idtechnicien.value
                };
            }
            clearMarkers(true);
        }
        // strategyGoogleMap renvoie une promesse
        // removeInfoPanel enleve le panneau #information_panel
        // qui indique les techniciens situés à la meme adresse
        // changeMapWidth augmente la taille de la carte (70% => 100%)
        // pour prendre la place laissee vide
        GoogleMapStarter.strategyGoogleMap(geolocType, planningFilters_async_obj).then(removeInfoPanel).then(changeMapWidth).then(callback);
    }
    if ($.isEmptyObject(planningFilters_obj)) {
        // Si je passe par une fonction, c'est que requireJs marche pas avec une fonction async (pour pouvoir avoir un await dedans)
        getFilters_planning().then(filtersLoaded);
    }
    else {
        filtersLoaded(planningFilters_obj);
    }
}
export function geolocalisationPosition() {
    Seed.Tab.GetFrame().find('#Planning').data("state", "position");
    updateGeoloc('position', {});
}
export function geolocalisationDepart() {
    Seed.Tab.GetFrame().find('#Planning').data("state", "depart");
    updateGeoloc('depart', {});
}
export function geolocalisationArrivee() {
    Seed.Tab.GetFrame().find('#Planning').data("state", "arrivee");
    updateGeoloc('arrivee', {});
}
export function geolocalisationTournee() {
    Seed.Tab.GetFrame().find('#Planning').data("state", "tour");
    updateGeoloc('tour', {});
}
/**
 * Appel du planning
 * @param string allOrParts = 'all' pour envoyer tout le planning (initialisation) ou 'parts' pour rafraichir sans supprimer la google map
 * @param int numdossier Numéro du dossier
 * @param string date Date
 * @param string calendarMode Mode du calendrier
 * @param string secteur Filtre sur le secteur
 * @param string agence Filtre sur l'agence
 * @param string tech Filtre sur le technicien
 * @param string competence Filtre sur la compétence
 * @param string tacheStdOrDetail : affichage standard de la tache ou détail
 * @param string planningTypeSemaine : semaine standard ou uniquement les jours travaillés
 */
function refreshPlanning(allOrParts, planningOrGeoloc, numdossier, date, calendarMode, secteur, agence, tech, idtech, competence, tacheStdOrDetail, planningTypeSemaine) {
    numdossier = numdossier ? numdossier : '';
    date = date ? date : '';
    calendarMode = calendarMode ? calendarMode : '';
    agence = agence ? agence : '';
    if (!secteur) {
        if (Seed.Tab.GetFrame().find('#secteur').val() !== null && typeof Seed.Tab.GetFrame().find('#secteur').val() !== 'undefined') {
            secteur = Seed.Tab.GetFrame().find('#secteur').val();
        }
        else {
            secteur = '';
        }
    }
    if (!tech) {
        if (Seed.Tab.GetFrame().find('#technicien').val() !== null && typeof Seed.Tab.GetFrame().find('#technicien').val() !== 'undefined') {
            tech = Seed.Tab.GetFrame().find('#technicien').val();
        }
        else {
            tech = '';
        }
    }
    if (!idtech) {
        let idtechnicienFromSeletedOption = Seed.Tab.GetFrame().find('#technicien')
            .children('option')
            .filter(':selected')
            .data('index');
        if (idtechnicienFromSeletedOption !== null && typeof idtechnicienFromSeletedOption !== 'undefined') {
            idtech = idtechnicienFromSeletedOption;
        }
        else {
            idtech = '';
        }
    }
    if (!competence) {
        if (Seed.Tab.GetFrame().find('#skill').val() !== null && typeof Seed.Tab.GetFrame().find('#skill').val() !== 'undefined') {
            competence = Seed.Tab.GetFrame().find('#skill').val();
        }
        else {
            competence = '';
        }
    }
    if (!tacheStdOrDetail) {
        if (Seed.Tab.GetFrame().find('#tache_std_or_detail').val() !== null && typeof Seed.Tab.GetFrame().find('#tache_std_or_detail').val() !== 'undefined') {
            tacheStdOrDetail = Seed.Tab.GetFrame().find('#tache_std_or_detail').val();
        }
        else {
            tacheStdOrDetail = '';
        }
    }
    if (!planningTypeSemaine) {
        if (Seed.Tab.GetFrame().find('#planning_type_semaine').val() !== null && typeof Seed.Tab.GetFrame().find('#planning_type_semaine').val() !== 'undefined') {
            planningTypeSemaine = Seed.Tab.GetFrame().find('#planning_type_semaine').val();
        }
        else {
            planningTypeSemaine = '';
        }
    }
    // close all popover
    $('.popover').popover('hide');
    Seed.Ajax.Post({
        url: "_module/Planning.php",
        data: "allOrParts=" + allOrParts
            + "&planningOrGeoloc=" + (planningOrGeoloc == 'geolocInit' ? 'geoloc' : planningOrGeoloc)
            + "&numdossier=" + numdossier
            + "&calendarMode=" + calendarMode
            + "&date=" + date
            + "&secteur=" + secteur
            + "&agence=" + agence
            + "&tech=" + tech
            + "&competence=" + competence
            + "&tacheStdOrDetail=" + tacheStdOrDetail
            + "&planningTypeSemaine=" + planningTypeSemaine,
        async: true,
        json: true,
        success: (jsonPlanning) => {
            if (allOrParts == 'all') {
                var parent = "#" + Seed.Tab.GetFrame().attr("id");
                parent = $(parent).find('.planning-panel');
                $(parent).html(jsonPlanning.full_planning_html);
            }
            else {
                // mise à jour separee des differentes zones du planning
                // pour preserver la partie googleMap
                // et preserver l'etat (actif/inactif) des boutons de geoloc
                // lorsqu'on appelle la geoloc la 1ere fois, planningOrGeoloc = geolocInit
                // => on met à jour les filtres du planning si planningOrGeoloc = geolocInit
                // ou planningOrGeoloc = planning
                // (pas de reinitialisation du type de geoloc au type position sinon)
                if (planningOrGeoloc != 'geoloc') {
                    Seed.Tab.GetFrame().find('#planning-geoloc-filters').html(jsonPlanning.geoloc_filters_html);
                    // mise à jour du planning uniquement en mode planning
                    if (planningOrGeoloc == 'planning') {
                        Seed.Tab.GetFrame().find('#Planning').html(jsonPlanning.planning_html);
                    }
                }
                Seed.Tab.GetFrame().find('#planning-select-filters').html(jsonPlanning.select_filters_html);
                Seed.Tab.GetFrame().find('#planning-dayWeekMonth-filters').html(jsonPlanning.dayWeekMonth_filters_html);
                Seed.Tab.GetFrame().find('#planning-datePicker-filters').html(jsonPlanning.datePicker_filters_html);
            }
            // le bouton 'geoloc' est disponible dans le planning seulement dans l'onglet planning principal
            // (pas dans un onglet planning ouvert depuis un dossier par exemple)
            // et s'il s'agit du 1er sous-onglet de l'onglet planning principal
            // (on peut ouvrir d'autres onglets planning en cliquant sur une tache puis sur le numero du dossier puis clic sur "prevu le")
            /*if(!Seed.Tab.GetFrame().parent().is('#planning_content') || !Seed.Tab.GetFrame().is(':first-child')){
                Seed.Tab.GetFrame().find('#geoloc_button').hide();
            }*/
            var jscript = document.createElement("SCRIPT");
            jscript.text = jsonPlanning.script;
            Seed.Tab.GetFrame().append(jscript);
            $(jscript).remove();
            // si le conteneur de la google map est affiché
            if (planningOrGeoloc != 'planning') {
                updateGeoloc(Seed.Tab.GetFrame().find('#Planning').data('state'), {});
            }
            resizeScreen();
            Seed.Planning.formatData();
            Seed.Planning.locking();
        }
    });
}
function refreshListPlanning(first) {
    var div = Seed.Tab.GetFrame().find('.task-panel')[0];
    if (first === true) {
        rqListSearch(3045, "", div);
    }
    else {
        if (Seed.Planning.isCartVisible()) {
            Seed.Planning.showCart();
            rqList("mydiv", 0, 3045, "", "");
        }
        else {
            Seed.Planning.hideCart();
        }
    }
}
//# sourceMappingURL=planningController.js.map